export default {
    data: () => ({
        importacaoCns: {
            regexValidacao: /^([a-zA-Z0-9áéíóúâêîôûãõäëïöüçÁÉÍÓÚÂÊÎÔÛÃÕÄËÏÖÜÇ'()/,\s-]+)$/
        }
    })
}